// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__fGEY2","footer":"ChangeClinic_footer__G0C77"};